// Video Popup ============================================================================

const watch_video = document.querySelectorAll('.watch-video');
const section_video = document.querySelector('#shopify-section-index-video');
const video = document.querySelector('#shopify-section-index-video video');
const iframe = document.querySelector('#shopify-section-index-video iframe');

if (watch_video.length > 0){
  const iframe_src = iframe.getAttribute('src');
  // Open video modal ------------------------------------
  watch_video.forEach( el => {
    el.onclick = e => {
      if (el.getAttribute('data-video')=='hero') {
        video.style.display="inline-block"
        iframe.style.display="none"
        section_video.classList.add('open-video');
      } else if(el.getAttribute('data-video')=='youtube') {
        iframe.style.display="inline-block"
        video.style.display="none"
        iframe.className='y-frame';
        iframe.parentElement.classList.add('y-wrapper');
        section_video.classList.add('open-video');
      }
    }
  });
	// Close video modal ------------------------------------
	section_video.addEventListener('click', function(e) {
    if ( !video.contains(e.target) ) {
      section_video.classList.remove('open-video');
      video.pause();
      video.currentTime = 0;
      iframe.setAttribute('src','');
      setTimeout(() => {
        iframe.setAttribute('src', iframe_src);
      }, 300);
    }
	})
}

// Exact vh for mobile ============================================================================

let vh = window.innerHeight * 0.01;   
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => { 
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
});

//Hamburer Menu Toggle ============================================================================

const hamburger = document.querySelector('.hamburger');
const menu = document.querySelector('.menus');
const close_menu = document.querySelector('.close-menu');
hamburger.onclick = e => { menu.classList.add('menu__open'); }
close_menu.onclick = e => { menu.classList.remove('menu__open'); }

//Accordion ============================================================================

var acc = document.getElementsByClassName("accordion");
var i;
for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    /* Toggle between adding and removing the "active" class,
    to highlight the button that controls the panel */
    this.classList.toggle("active");
    /* Toggle between hiding and showing the active panel */
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      this.querySelector('span').innerText="+"
      panel.style.display = "none";
    } else {
      this.querySelector('span').innerText="-"
      panel.style.display = "block";
    }
  });
}

//Tab Toggler ============================================================================

function openTab(evt, tabname) {
  // Declare all variables
  var i, tabcontent, tablinks;
  // Get all elements with class="tabcontent" and hide them
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  // Get all elements with class="tablinks" and remove the class "active"
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  // Show the current tab, and add an "active" class to the button that opened the tab
  document.getElementById(tabname).style.display = "block";
  evt.currentTarget.className += " active";
}

// Get the element with id="defaultOpen" and click on it
var defaultTab = document.getElementById("defaultOpen");
if (defaultTab) defaultTab.click();
